"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find");
var _inkhubMonthly = require("../../api/inkhubMonthly.js");
var _apprepair = require("../../api/apprepair.js");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "InkhubMonthly",
  data: function data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      currentPage: 1,
      multipleSelection: [],
      type: [],
      form: {
        period: "",
        theme: "",
        language: "",
        pageNo: 1,
        pageSize: 10
      },
      forms: {
        period: "",
        theme: "",
        language: "",
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _apprepair.getLanList)({
      name: "lan"
    }).then(function (res) {
      _this.type = res.dictionaryVOList || [];
    });
    this.getList();
    // 标记：mounted 已经做过首刷；从新增/编辑页返回时 activated() 应触发刷新
    this._inkhubListInited = true;
  },
  activated: function activated() {
    // keep-alive 从新增/编辑页返回时刷新；首次挂载已在 mounted 中查询，避免重复请求
    if (this._inkhubListInited) {
      this.getList();
    } else {
      this._inkhubListInited = true;
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    },
    languageFormatter: function languageFormatter(row) {
      var item = this.type.find(function (lang) {
        return lang.value === row.language || lang.valueCn === row.language;
      });
      return item ? item.valueCn : row.language;
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      setTimeout(function () {
        (0, _inkhubMonthly.queryInkhubMonthly)(_this2.forms).then(function (res) {
          if (res.voList == null || res.voList == "") {
            _this2.forms.pageNo = 1;
            _this2.currentPage = 1;
            (0, _inkhubMonthly.queryInkhubMonthly)(_this2.forms).then(function (res) {
              _this2.tableData = res.voList || [];
              _this2.total = Number(res.total) || 0;
              _this2.loading = false;
            });
          } else {
            _this2.tableData = res.voList || [];
            _this2.total = Number(res.total) || 0;
            _this2.loading = false;
          }
        });
      }, 500);
    },
    changepage: function changepage(currentPage) {
      this.currentPage = currentPage;
      this.forms.pageNo = currentPage;
      this.getList();
    },
    search: function search() {
      this.currentPage = 1;
      this.forms.pageNo = 1;
      this.forms.theme = this.form.theme;
      this.forms.period = this.form.period;
      this.forms.language = this.form.language;
      this.getList();
    },
    empty: function empty() {
      this.form.period = "";
      this.form.theme = "";
      this.form.language = "";
      this.forms.period = "";
      this.forms.theme = "";
      this.forms.language = "";
      this.currentPage = 1;
      this.forms.pageNo = 1;
      this.getList();
    },
    add: function add() {
      this.$router.push({
        path: "/other/addInkhubMonthly",
        query: {
          cur: String(this.currentPage)
        }
      });
    },
    editByPeriod: function editByPeriod() {
      if (this.multipleSelection.length !== 1) {
        this.msgTip("warning", "请选择一条数据");
        return;
      }
      var row = this.multipleSelection[0];
      if (row.period == null || row.period === "") {
        this.msgTip("error", "缺少期数，无法按期编辑");
        return;
      }
      this.$router.push({
        path: "/other/editInkhubMonthly",
        query: {
          period: String(row.period),
          cur: String(this.currentPage)
        }
      });
    },
    openCreateArticle: function openCreateArticle() {
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
      var baseUrl = (userType == "cn" ? "https://html-scaffold.supernote.com.cn" : "https://html-scaffold.supernote.com").replace(/\/$/, "");
      var token = window.localStorage.getItem("token") || (0, _auth.getToken)() || this.$store.getters.token || "";
      if (!token) {
        this.msgTip("error", "未获取到登录 token，请重新登录");
        return;
      }
      var encoded = encodeURIComponent(token);
      // query 在 nginx 重定向时可能被丢弃；hash 不会发给服务端，可保留 token
      window.open("".concat(baseUrl, "/?token=").concat(encoded, "#token=").concat(encoded), "_blank", "noopener,noreferrer");
    },
    dele: function dele() {
      var _this3 = this;
      if (this.multipleSelection.length < 1) {
        this.msgTip("warning", "请选择至少一条数据");
        return;
      }
      this.$confirm("您是否要删除当前选中的记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var ids = _this3.multipleSelection.map(function (item) {
          return item.id;
        });
        (0, _inkhubMonthly.batchDeleteInkhubMonthly)({
          ids: ids
        }).then(function (res) {
          if (res.success) {
            _this3.msgTip("success", "删除成功");
            _this3.getList();
          } else {
            _this3.msgTip("error", res.errorMsg);
          }
        }).catch(function () {
          _this3.msgTip("error", "删除失败");
        });
      });
    },
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    }
  }
};